import React, { CSSProperties } from 'react';
import ReactMarkdown from 'react-markdown';
import { I18nManager, useWindowDimensions } from 'react-native';
import { useTheme } from 'styled-components/native';

import { padding } from '@src/configuration/constants';

import { Props } from './types';

const Markdown: React.FC<Props> = ({ children, level = 0 }) => {
  const theme = useTheme();
  const dimensions = useWindowDimensions();
  const imageStyle = React.useMemo(
    () =>
      ({
        maxWidth: dimensions.width - padding * 2,
        margin: 'auto',
        borderRadius: 4,
      } as CSSProperties),
    [dimensions.width]
  );
  const containerStyle = React.useMemo(
    () =>
      ({
        fontFamily: theme.fonts.light.fontFamily,
        color: theme.colors.text,
        direction: I18nManager.isRTL ? 'rtl' : 'ltr',
        fontSize: theme.typography.body[1].fontSize + level * 2,
        lineHeight: `${theme.typography.body[1].lineHeight + level * 2}px`,
      } as CSSProperties),
    [
      level,
      theme.colors.text,
      theme.fonts.light.fontFamily,
      theme.typography.body,
    ]
  );
  const renderers = React.useMemo(
    () => ({
      //This custom renderer changes how images are rendered
      //we use it to constrain the max width of an image to its container
      image: ({
        alt,
        src,
        title,
      }: {
        alt?: string;
        src?: string;
        title?: string;
      }) => <img alt={alt} src={src} title={title} style={imageStyle} />,
    }),
    [imageStyle]
  );

  return (
    <div style={containerStyle}>
      <ReactMarkdown renderers={renderers}>{children ?? ''}</ReactMarkdown>
    </div>
  );
};

export default React.memo(Markdown);
